import { defineMessages } from "react-intl";

export const messages = defineMessages({
  pipelineTitle: {
    id: "naHkpT",
    defaultMessage: "Import Pipeline",
    description: "import pipeline section title",
  },
  pipelineDescription: {
    id: "5376yt",
    defaultMessage:
      "Import data in order: start with Categories and Product Types before importing Products and Variants. Each step depends on the previous one.",
    description: "import pipeline description",
  },
});
